import { Outlet } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PageContent, PageHeader } from '@nucleus-commerce/admin-kit/layout';

import { useStore } from '@/shared/store/store-context';

import { ReportTabs } from '../components/report-tabs';

/** Title and tabs shared by every report; the tab renders its own range bar. */
export function ReportsLayout() {
  const { t } = useTranslation('reports');
  const store = useStore();
  return (
    <PageContent>
      <PageHeader title={t('title')} description={t('description', { store: store.name })} />
      <ReportTabs storeId={store.id} />
      <Outlet />
    </PageContent>
  );
}
